export var PERIOD_TYPES = {
  HOURLY: '0',
  DAILY: '1',
  WEEKLY: '2',
  MONTHLY: '3',
  YEARLY: '4'
};